import { FormControlLabel, Switch, TextField } from "@mui/material";
import { sanitizePlainText } from "../utils/inputValidation";
import { readChatAccessGateFromSettings } from "../utils/chatAccessGate";
import { AUTH_FIELD_SX } from "../pages/AuthLayout";

const fieldSx = { ...AUTH_FIELD_SX, maxWidth: "100%", width: "100%" };

export default function ProjectChatAccessGate({
  settings,
  availableMessengers = ["telegram", "max"],
  onChange,
  readOnly = false,
}) {
  const gate = readChatAccessGateFromSettings(settings);
  const showTelegram = availableMessengers.includes("telegram");
  const showMax = availableMessengers.includes("max");

  const patchGate = (patch) => {
    if (readOnly || !onChange) return;
    onChange({ ...gate, ...patch });
  };

  return (
    <div className="app-chat-access-gate">
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={gate.requireChatMembership}
            onChange={(event) =>
              patchGate({ requireChatMembership: event.target.checked })
            }
            disabled={readOnly}
          />
        }
        label="Доступ только для участников корпоративного чата"
      />

      <p className="app-chat-access-gate__hint">
        Бот проверит, состоит ли сотрудник в указанном чате, прежде чем открыть
        проект. Добавьте бота в групповой чат и выдайте ему права администратора.
      </p>

      {gate.requireChatMembership ? (
        <div className="app-chat-access-gate__fields">
          {showTelegram ? (
            <div className="app-chat-access-gate__messenger-block">
              <span className="app-chat-access-gate__messenger-label">Telegram</span>
              <TextField
                label="ID или @username чата"
                size="small"
                fullWidth
                sx={fieldSx}
                value={gate.accessTelegramChatId}
                onChange={(event) =>
                  patchGate({
                    accessTelegramChatId: sanitizePlainText(event.target.value, 120),
                  })
                }
                placeholder="-1001234567890 или @sales_team"
                disabled={readOnly}
              />
              <TextField
                label="Название чата для сообщения сотруднику"
                size="small"
                fullWidth
                sx={fieldSx}
                value={gate.accessTelegramChatTitle}
                onChange={(event) =>
                  patchGate({
                    accessTelegramChatTitle: sanitizePlainText(event.target.value, 120),
                  })
                }
                placeholder="Например: Продажи"
                disabled={readOnly}
              />
            </div>
          ) : null}

          {showMax ? (
            <div className="app-chat-access-gate__messenger-block">
              <span className="app-chat-access-gate__messenger-label">MAX</span>
              <TextField
                label="chat_id группового чата"
                size="small"
                fullWidth
                sx={fieldSx}
                value={gate.accessMaxChatId}
                onChange={(event) =>
                  patchGate({
                    accessMaxChatId: sanitizePlainText(event.target.value, 40),
                  })
                }
                placeholder="123456789"
                disabled={readOnly}
              />
              <TextField
                label="Название чата для сообщения сотруднику"
                size="small"
                fullWidth
                sx={fieldSx}
                value={gate.accessMaxChatTitle}
                onChange={(event) =>
                  patchGate({
                    accessMaxChatTitle: sanitizePlainText(event.target.value, 120),
                  })
                }
                placeholder="Например: Продажи"
                disabled={readOnly}
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
